<template>
  <main class="auth-screen">
    <div class="auth-shell">
      <header class="auth-topbar">
        <router-link class="auth-logo" to="/">
          <div class="brand-mark">
            <img src="/img/boarua-icon-concept-v1.png" alt="" />
          </div>
          <span>BOARUA</span>
        </router-link>

        <router-link class="auth-back" to="/">
          <v-icon size="18">mdi-arrow-left</v-icon>
          Voltar
        </router-link>
      </header>

      <section class="auth-card">
        <header class="auth-heading">
          <h1>Bem-vindo!</h1>
          <p>Acesse a sua conta</p>
        </header>

        <v-form ref="form" v-model="loginForm.validForm" lazy-validation @submit.prevent="login">
          <v-text-field
            ref="username"
            v-model="loginForm.user.email"
            :rules="[$rules.required]"
            autocomplete="email"
            class="auth-field"
            hide-details="auto"
            outlined
            placeholder="Seu e-mail"
            type="email"
          />

          <v-text-field
            id="password"
            v-model="loginForm.user.password"
            :append-icon="loginForm.showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :rules="[$rules.required]"
            :type="loginForm.showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            class="auth-field"
            hide-details="auto"
            outlined
            placeholder="Sua senha"
            @click:append="loginForm.showPassword = !loginForm.showPassword"
          />

          <v-btn block depressed class="auth-button" :loading="loginForm.loading" type="submit">
            Entrar
          </v-btn>

          <div class="auth-links">
            <router-link :to="{ path: '/recuperar-senha', query: { email: loginForm.user.email } }">
              Esqueceu sua senha?
            </router-link>
          </div>

          <p class="signup-link">
            Primeiro acesso?
            <router-link to="/criar-conta">Criar conta</router-link>
          </p>

          <router-link class="verify-link" :to="{ path: '/verificar-conta', query: { email: loginForm.user.email } }">
            Verificar conta
          </router-link>
        </v-form>
      </section>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import * as jwt from "jwt-decode";

export default {
  name: "Login",

  data: () => ({
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {
        email: "",
        password: "",
      },
    },
  }),

  mounted() {
    if (this.$route.query.email) {
      this.loginForm.user.email = this.$route.query.email;
    }
  },

  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;

      this.loginForm.loading = true;

      try {
        const result = await this.tryLogin();

        if (!result.data.content.token) throw new Error();

        localStorage.setItem("token", JSON.stringify(result.data.content));

        const dataUser = jwt(result.data.content.token);
        this.$root.user = dataUser;
        localStorage.setItem("user", JSON.stringify(dataUser));

        try {
          const roleId = dataUser && (dataUser.role_id || dataUser.roleId || (dataUser.data && dataUser.data.role_id));
          if (roleId) {
            const permRes = await axios.get(`/roles/${roleId}/permissions`);
            const perms = permRes && permRes.data && permRes.data.content && permRes.data.content.permissions ? permRes.data.content.permissions : [];
            localStorage.setItem("profilePermissions", JSON.stringify(perms));
          }
        } catch (e) {
          localStorage.setItem("profilePermissions", JSON.stringify([]));
        }

        if (Number(dataUser.type) === 5) return this.$router.push("/seguranca");
        if (Number(dataUser.type) === 6) return this.$router.push("/portaria/autorizacoes");
        this.$router.push("/home");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
        this.loginForm.user.password = "";
      } finally {
        this.loginForm.loading = false;
      }
    },
    async tryLogin() {
      const payload = {
        username: this.loginForm.user.email,
        password: this.loginForm.user.password,
      };

      try {
        return await axios.post("/sessions", { ...payload, type: 1 });
      } catch (adminError) {
        try {
          return await axios.post("/sessions", { ...payload, type: 5 });
        } catch (securityError) {
          return axios.post("/sessions", { ...payload, type: 6 });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.auth-screen {
  min-height: 100vh;
  padding: 24px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111827;
  background: #eef0ef;
}

.auth-shell {
  width: min(100%, 520px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.auth-topbar {
  width: 100%;
  margin-bottom: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  position: relative;
}

.auth-logo {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #057a3d;
  font-size: 42px;
  font-weight: 900;
  letter-spacing: 0;
  text-decoration: none;
}

.auth-back {
  min-height: 38px;
  padding: 0 15px 0 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  position: absolute;
  right: 0;
  color: #123024;
  background: #ffffff;
  border: 1px solid #dce2de;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;

  .v-icon {
    color: #057a3d;
  }
}

.brand-mark {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dce2de;
  border-radius: 12px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.auth-card {
  width: 100%;
  padding: 38px 54px 34px;
  background: #ffffff;
  border: 1px solid #f5f6f5;
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(17, 24, 39, 0.04);
}

.auth-heading {
  margin-bottom: 26px;
  text-align: center;

  h1 {
    margin: 0;
    color: #1d2023;
    font-size: 31px;
    font-weight: 900;
    letter-spacing: 0;
  }

  p {
    margin: 10px 0 0;
    color: #5c6062;
    font-size: 23px;
    font-weight: 500;
  }
}

.auth-field {
  margin-bottom: 0;

  & + .auth-field {
    margin-top: 18px;
  }

  ::v-deep .v-input__slot {
    min-height: 52px !important;
    background: #f2f4f3 !important;
    border-radius: 8px;
  }

  ::v-deep fieldset {
    border-color: #c9ced0 !important;
  }

  ::v-deep input {
    color: #1d2023;
    font-size: 16px;
  }

  ::v-deep input::placeholder {
    color: #8a8d90;
    opacity: 1;
  }
}

.auth-button {
  height: 56px !important;
  margin-top: 30px;
  color: #ffffff;
  background: #00843d !important;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}

.auth-links {
  margin-top: 20px;
  text-align: center;

  a {
    color: #2e3030;
    font-size: 15px;
    font-weight: 900;
    text-decoration: none;
  }
}

.signup-link {
  margin: 30px 0 0;
  color: #2e3030;
  font-size: 17px;
  font-weight: 500;
  text-align: center;

  a {
    color: #057a3d;
    font-weight: 900;
    text-decoration: none;
  }
}

.verify-link {
  margin-top: 14px;
  display: block;
  color: #69706c;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  text-decoration: none;
}

@media (max-width: 640px) {
  .auth-screen {
    padding: 26px 14px;
  }

  .auth-topbar {
    margin-bottom: 24px;
    justify-content: space-between;
  }

  .auth-logo {
    font-size: 31px;
  }

  .auth-back {
    min-height: 36px;
    padding: 0 12px 0 10px;
    position: static;
  }

  .brand-mark {
    width: 42px;
    height: 42px;
  }

  .auth-card {
    padding: 30px 22px 26px;
  }

  .auth-heading p {
    font-size: 18px;
  }
}
</style>
